import React, { useState } from 'react';
import interviewService from '../services/interviewService';

const CompleteInterviewModal = ({ interview, onClose, onSuccess }) => {
  const [outcome, setOutcome] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!outcome) {
      setError('Please select an outcome');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await interviewService.completeInterview(interview._id, {
        outcome,
        notes
      });

      if (response.success) {
        onSuccess(outcome);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to complete interview');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] p-5" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.3)] max-w-2xl w-full max-h-[90vh] overflow-y-auto mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center px-6 py-5 border-b border-[#e9ecef]">
          <h2 className="m-0 text-[#2c3e50] text-2xl">Complete Interview</h2>
          <button className="bg-transparent border-none text-[2rem] text-[#6c757d] cursor-pointer p-0 w-8 h-8 flex items-center justify-center rounded transition-all duration-200 hover:bg-[#f8f9fa] hover:text-[#2c3e50]" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          {error && <div className="bg-[#f8d7da] text-[#721c24] px-4 py-3 rounded-md mb-5 border border-[#f5c6cb] text-[0.95rem]">{error}</div>}

          <div className="mb-5">
            <label className="block mb-2 font-medium text-[#495057] text-[0.95rem]">Outcome *</label>
            <div className="grid grid-cols-2 gap-3 mb-5">
              <button
                type="button"
                className={`p-4 border-2 rounded-lg bg-white cursor-pointer transition-all duration-200 text-base font-medium ${
                  outcome === 'PASSED' 
                    ? 'border-[#28a745] bg-[#d4edda] text-[#155724]' 
                    : 'border-[#dee2e6] hover:border-[#007bff]'
                }`}
                onClick={() => setOutcome('PASSED')}
              >
                ✓ PASSED
              </button>
              <button
                type="button"
                className={`p-4 border-2 rounded-lg bg-white cursor-pointer transition-all duration-200 text-base font-medium ${
                  outcome === 'FAILED' 
                    ? 'border-[#dc3545] bg-[#f8d7da] text-[#721c24]' 
                    : 'border-[#dee2e6] hover:border-[#007bff]'
                }`}
                onClick={() => setOutcome('FAILED')}
              >
                ✗ FAILED
              </button>
            </div>
          </div>

          <div className="mb-5">
            <label htmlFor="notes" className="block mb-2 font-medium text-[#495057] text-[0.95rem]">Notes</label>
            <textarea
              id="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add interview feedback..."
              rows={4}
              maxLength={2000}
              disabled={loading}
              className="w-full px-3 py-2.5 border border-[#ced4da] rounded-md text-base transition-[border-color] duration-200 resize-y font-[inherit] focus:outline-none focus:border-[#007bff] focus:shadow-[0_0_0_3px_rgba(0,123,255,0.1)] disabled:bg-[#e9ecef] disabled:cursor-not-allowed"
            />
          </div>

          <div className="flex justify-end gap-3 mt-6 pt-5 border-t border-[#e9ecef] md:flex-col-reverse md:[&>button]:w-full">
            <button type="button" className="px-5 py-2.5 border-none rounded-md text-base font-medium cursor-pointer transition-all duration-200 bg-[#6c757d] text-white hover:bg-[#5a6268] disabled:opacity-60 disabled:cursor-not-allowed" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="px-5 py-2.5 border-none rounded-md text-base font-medium cursor-pointer transition-all duration-200 bg-[#007bff] text-white hover:bg-[#0056b3] disabled:opacity-60 disabled:cursor-not-allowed" disabled={loading || !outcome}>
              {loading ? 'Completing...' : 'Complete Interview'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompleteInterviewModal;
